import {
  validateFormat,
  validatePresence
} from "ember-changeset-validations/validators";

export default {
  email: [
    validatePresence({ presence: true }),
    validateFormat({
      type: "email",
      message: "Saisissez une adresse email valide"
    })
  ],
  password: validatePresence({
    presence: true,
    description: "Le mot de passe"
  })
};
